import { SVGProps, Ref, forwardRef } from 'react';

export const FlameFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m9.851 1 .865.529c2.871 1.754 3.777 4.218 3.94 6.227.06.726.022 1.39-.048 1.939a6 6 0 0 0 1.563-1.048c.359-.33.702-.7.962-1.115l.592-.986.815.815c2.996 2.998 3.622 6.907 2.309 10.094C19.532 20.648 16.317 23 11.905 23c-5.472 0-10.43-4.528-9.222-10.968.46-2.451 1.79-3.995 3.13-5.402 1.353-1.42 2.693-2.69 3.616-4.708z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlameFilledSize24Glyph.displayName = 'FlameFilledSize24Glyph';
